// Sport-specific positions and specialities configuration

export const SPORT_POSITIONS = {
  'Football': [
    'Goalkeeper',
    'Defender',
    'Centre-Back',
    'Full-Back',
    'Wing-Back',
    'Midfielder',
    'Defensive Midfielder',
    'Central Midfielder',
    'Attacking Midfielder',
    'Winger',
    'Forward',
    'Striker',
    'Second Striker'
  ],
  'Basketball': [
    'Point Guard (PG)',
    'Shooting Guard (SG)',
    'Small Forward (SF)',
    'Power Forward (PF)',
    'Center (C)',
    'Combo Guard',
    'Swingman',
    'Stretch Four'
  ],
  'Cricket': [
    'Opening Batsman',
    'Top Order Batsman',
    'Middle Order Batsman',
    'Wicket-keeper Batsman',
    'Fast Bowler',
    'Spin Bowler',
    'All-rounder',
    'Wicket-keeper'
  ],
  'Rugby': [
    'Prop',
    'Hooker',
    'Lock',
    'Flanker',
    'Number 8',
    'Scrum-half',
    'Fly-half',
    'Centre',
    'Wing',
    'Fullback'
  ],
  'Volleyball': [
    'Setter',
    'Outside Hitter',
    'Opposite Hitter',
    'Middle Blocker',
    'Libero',
    'Defensive Specialist'
  ],
  'Tennis': [
    'Singles Player',
    'Doubles Player',
    'Mixed Doubles',
    'All-Court Player',
    'Baseline Player',
    'Serve-and-Volley'
  ],
  'Swimming': [
    'Freestyle',
    'Backstroke',
    'Breaststroke',
    'Butterfly',
    'Individual Medley (IM)',
    'Sprint',
    'Distance'
  ],
  'Track & Field': [
    'Sprinter (100m-400m)',
    'Middle Distance (800m-1500m)',
    'Long Distance (5000m-Marathon)',
    'Hurdler',
    'Relay',
    'High Jump',
    'Long Jump',
    'Triple Jump',
    'Pole Vault',
    'Shot Put',
    'Discus',
    'Javelin',
    'Hammer Throw',
    'Decathlon/Heptathlon'
  ],
  'Baseball': [
    'Pitcher',
    'Catcher',
    'First Baseman',
    'Second Baseman',
    'Third Baseman',
    'Shortstop',
    'Left Fielder',
    'Center Fielder',
    'Right Fielder',
    'Designated Hitter'
  ],
  'Hockey': [
    'Goalkeeper',
    'Defender',
    'Midfielder',
    'Forward',
    'Centre Forward',
    'Wing'
  ],
  'Badminton': [
    'Singles Player',
    'Doubles Player',
    'Mixed Doubles',
    'All-Rounder'
  ],
  'Table Tennis': [
    'Singles Player',
    'Doubles Player',
    'Offensive Player',
    'Defensive Player',
    'All-Round Player'
  ],
  'Boxing': [
    'Lightweight',
    'Welterweight',
    'Middleweight',
    'Heavyweight',
    'Super Heavyweight'
  ],
  'MMA': [
    'Flyweight',
    'Bantamweight',
    'Featherweight',
    'Lightweight',
    'Welterweight',
    'Middleweight',
    'Light Heavyweight',
    'Heavyweight'
  ],
  'Cycling': [
    'Sprinter',
    'Climber',
    'Time Trialist',
    'All-Rounder',
    'Track Cyclist',
    'BMX Rider',
    'Mountain Biker'
  ],
  'Golf': [
    'Professional',
    'Amateur',
    'Tour Player',
    'Club Professional'
  ],
  'Gymnastics': [
    'Artistic Gymnastics',
    'Rhythmic Gymnastics',
    'Trampoline',
    'Acrobatic Gymnastics',
    'All-Around'
  ]
};

// Get positions for a specific sport
export const getPositionsForSport = (sport) => {
  return SPORT_POSITIONS[sport] || [];
};

// Check if sport has positions
export const sportHasPositions = (sport) => {
  return sport && SPORT_POSITIONS[sport] && SPORT_POSITIONS[sport].length > 0;
};
